import { TagsValidation } from "../models";

export const validateTagLengthAndPattern =
    (inputElement: HTMLInputElement) =>
    (tagsValidation: TagsValidation): TagsValidation => {
        if (tagsValidation !== TagsValidation.Valid) {
            return tagsValidation;
        }

        const {
            validity: { patternMismatch, tooShort },
            value,
        } = inputElement;

        if (value === "") {
            return TagsValidation.Valid;
        }

        if (patternMismatch) {
            return TagsValidation.NonAlphanumeric;
        } else if (tooShort) {
            return TagsValidation.TooShort;
        } else {
            return TagsValidation.Valid;
        }
    };
